import React from 'react';

import { createAuthenticatedHubConnection } from '@dec/shared';
import * as signalR from '@microsoft/signalr';
import auth from 'app/core/auth';
import Env from 'env';

import { type SocketConnection } from '../models/types';

export const createTaxReturnNotificationsConnection = () => {
  return createAuthenticatedHubConnection({
    url: `${Env.serverApplication}/TaxReturnNotifications`,
    accessTokenFactory: () => auth.getAccessToken(),
    configureLogging: (builder) => builder.configureLogging(signalR.LogLevel.Information)
  });
};

export const createInboxNotificationsConnection = () => {
  return createAuthenticatedHubConnection({
    url: `${Env.serverApplication}/InboxNotifications`,
    accessTokenFactory: () => auth.getAccessToken(),
    configureLogging: (builder) => builder.configureLogging(signalR.LogLevel.None)
  });
};

export const TaxReturnNotificationsConnection = React.createContext<SocketConnection>({
  connection: undefined
});
